export enum AmplitudeEvents {
  //Entry point
  SEARCH_ENTRYPOINT_VIEW = 'searchEntryPoint_view',
  SEARCH_ENTRYPOINT_SALE_VIEW = 'searchentrypointSale_view',
  SEARCH_ENTRYPOINT_LEASE_VIEW = 'searchentrypointLease_view',
  SEARCH_ENTRYPOINT_CUSTOM_VIEW = 'searchentrypointCustomSearch_view',
  SEARCH_ENTRYPOINT_SALE_ACTION = 'searchentrypointSale_action',
  SEARCH_BYID_ACTION = 'searchById_action',
  //Results
  SEARCH_RESULTS_VIEW = 'searchResults_view',
  SEARCH_RESULTS_GOTO_PROPERTYDETAIL = 'searchGoToPropertyDetail_action',
  SEARCH_RESULTS_MOREFILTERS_VIEW = 'searchResultMoreFilters_view',
  SEARCH_RESULTS_MOREFILTERS_ACTION = 'searchResultsMoreFilters_action',
  SEARCH_RESULTS_MAPCLUSTER_ACTION = 'searchResultsMapCluster_action',
  SEARCH_RESULTS_OPPORTUNITIES_ACTION = 'searchResultsOpportunities_action',
  SEARCH_RESULTS_PROPERTYTYPES_ACTION = 'searchResultsPropertyTypes_action',
  SEARCH_RESULTS_ASSOCIATIONS_ACTION = 'searchResultsAssociations_action',
  SEARCH_RESULTS_PRICES_ACTION = 'searchResultsPrices_action',
  SEARCH_RESULTS_OPERATIONTYPE_ACTION = 'searchResultsOperationType_action',
  SEARCH_RESULTS_LOCATION_ACTION = 'searchResultsLocation_action',
  SEARCH_RESULTS_WIZZARD_VIEW = 'searchResultsWizzard_view',
  SEARCH_RESULTS_SHARECOMMISSION_ACTION = 'searchResultsShareCommission_action',
  SEARCH_RESULTS_ADDPROPERTYLIST_VIEW = 'searchResultsAddPropertyList_view',
  SEARCH_RESULTS_ADDPROPERTYLIST_ACTION = 'searchResultsAddPropertyList_action',
  //Property detail
  PROPERTYDETAIL_VIEW = 'datasheet_view',
  PROPERTYDETAIL_USER_CONTACT_ACTION = 'datasheetContact_action',
  COMPA_ACTION = 'compaInfo_action'
}
